// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3QVl1","options":"AnswerScale_options__au3o0","selected":"AnswerScale_selected__2f2vO"};